import { c as _c } from "react/compiler-runtime";
import { Box, Stack, Text, Icon, SystemStyleObject } from "@chakra-ui/react";
import { HazardLegendKind } from "../data/hazard-map-config";
type LegendSymbolProps = {
  kind: HazardLegendKind;
};
const LegendSymbol = t0 => {
  const $ = _c(5);
  const {
    kind
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      base: "4",
      md: "5"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const size = t1 as const;
  switch (kind) {
    case "softStory":
      {
        let t2;
        if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
          t2 = <Box data-testid="hazard-legend-softStory" aria-hidden="true" w={size} h={size} flexShrink={0} borderRadius="full" bg="grey.400" border="softStoryLegend" />;
          $[1] = t2;
        } else {
          t2 = $[1];
        }
        return t2;
      }
    case "liquefaction":
      {
        let t2;
        if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
          t2 = <Box data-testid="hazard-legend-liquefaction" aria-hidden="true" w={size} h={size} flexShrink={0} borderRadius="sm" bgColor="liquefaction.background" border="md" borderColor="liquefaction.border" boxShadow="liquefaction" />;
          $[2] = t2;
        } else {
          t2 = $[2];
        }
        return t2;
      }
    case "tsunami":
      {
        let t2;
        if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
          t2 = <Box data-testid="hazard-legend-tsunami" aria-hidden="true" w={size} h={size} flexShrink={0} borderRadius="sm" backgroundImage="tsunamiHatch" backgroundRepeat="repeat" backgroundSize="16px 16px" backgroundColor="tsunami/40" border="sm" borderColor="tsunami/35" />;
          $[3] = t2;
        } else {
          t2 = $[3];
        }
        return t2;
      }
    case "femaRisk":
      {
        let t2;
        if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
          t2 = <Box data-testid="hazard-legend-femaRisk" aria-hidden="true" w={size} h={size} flexShrink={0} borderRadius="sm" backgroundColor="white" backgroundImage="fema" border="sm" borderColor="femaRisk.veryHigh" backgroundClip="padding-box" />;
          $[4] = t2;
        } else {
          t2 = $[4];
        }
        return t2;
      }
  }
};
type KeyElemProps = {
  name: string;
  legend?: HazardLegendKind;
  color?: SystemStyleObject["color"];
  icon?: React.ReactNode;
};
export const KeyElem = t0 => {
  const $ = _c(10);
  const {
    name,
    legend,
    color,
    icon
  } = t0;
  let t1;
  if ($[0] !== color || $[1] !== icon || $[2] !== legend) {
    t1 = legend ? <LegendSymbol kind={legend} /> : icon ? <Icon size={{
      base: "sm",
      md: "md"
    }} color={color}>{icon}</Icon> : null;
    $[0] = color;
    $[1] = icon;
    $[2] = legend;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      base: "textSmall",
      md: "textMedium"
    };
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== name) {
    t3 = <Text textStyle={t2} layerStyle="headerAlt" fontWeight="bold" whiteSpace="nowrap">{name}</Text>;
    $[5] = name;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t1 || $[8] !== t3) {
    t4 = <Stack direction="row" alignItems="center">{t1}{t3}</Stack>;
    $[7] = t1;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};